import cls from "./customInnerPage.module.scss";
import React, {Dispatch, FC, ReactNode, SetStateAction} from "react";
import InputNumber from "../../shared/InputNumber";
import {setFormPopupOpen} from "../../../store/formbuilder";
import {useDispatch} from "react-redux";
import {IFormComponentType} from "../../builder/types";
import {IRequestFormDetails} from "../../../pages/[productSlug]";

interface ICustomSideBar {
    ProductAddToCart_INTL: string;
    actionClassName: string;
    handleCardClick: (quantity: number) => Promise<boolean | void | {message: string, resStatus: number}>;
    isButtonDisabled: boolean;
    wishListButtonClick: (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
    wishIconClicked: ReactNode;
    inpValQuantity: number;
    requestFormInfo: IFormComponentType | null;
    requestFormDetails: IRequestFormDetails
}

const CustomSideBar: FC<ICustomSideBar> = (
    {
        ProductAddToCart_INTL,
        actionClassName,
        handleCardClick,
        isButtonDisabled,
        wishListButtonClick,
        wishIconClicked,
        inpValQuantity,
        requestFormDetails,
        requestFormInfo
    }
) => {
    const dispatch = useDispatch();
    const Button = (
        {className = "", title = ProductAddToCart_INTL, onClick = () => handleCardClick(inpValQuantity), isButtonDisabledInside = false}
            : {className?: string, title?: string, onClick?: () => any, isButtonDisabledInside?: boolean}
    ) => {
        return <div
            className={`${cls["product__actions-item"]} ${cls["product__actions-item--addToCart"]}`}>
            <div className={`${cls["product__actions-item"]} ${cls["product__actions-item--addToCart"]} ${actionClassName}`}>
                <button
                    onClick={async (e) => {
                        e.preventDefault();
                        await onClick()
                    }}
                    disabled={isButtonDisabledInside}
                    className={`btn btn-orange ${cls["inner-addToCart"]} ${cls["rounded-pills"]} btn-lg ${className}`}
                >
                    {title}
                </button>
            </div>
        </div>
    }
    return (
        <div className={cls["product__sidebar"]}>
            <form className={cls["product__options"]}>
                <div className={`form-group ${cls["product__option"]}`}>
                    <div className={cls["product__actions"]}>
                        <div className={`${cls["product__actions-last__items"]}`}>
                            <div className={cls["inner-buttons-wrapper"]}>
                                <Button isButtonDisabledInside={isButtonDisabled}/>
                                {Number(requestFormDetails?.requestFormActive) && requestFormDetails?.requestFormBtn ? (
                                    <Button
                                        isButtonDisabledInside={false}
                                        className={"inner-request-form-button"}
                                        title={requestFormDetails?.requestFormBtn}
                                        onClick={() => dispatch(setFormPopupOpen({
                                            id: requestFormInfo?.data?.id,
                                            open: true
                                        }))}
                                    />
                                ) : null}
                            </div>
                            <div
                                className={`
                                ${cls["product__actions-item"]}
                                ${cls["product__actions-item--wishlist"]}
                                ${cls["liked-button-wrapper"]}
                                ${requestFormDetails?.requestFormBtn ? cls["like-btn-self-flex"] : ""}
                            `}>
                                <span className={cls['product__actions_wish-icon']}>
                                    <button
                                        aria-label="Wish list"
                                        title="Wishlist"
                                        onClick={wishListButtonClick}
                                        className="btn-light btn-svg-icon btn-svg-icon--fake-svg"
                                    >
                                        <div className={cls["wishlist-icon-wrapper"]}>
                                            {wishIconClicked}
                                        </div>
                                    </button>
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        </div>
    )
}

export default CustomSideBar;
